var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92962 1.14142C7.00773 1.06332 7.13436 1.06332 7.21247 1.14142L7.63672 1.56567C7.71482 1.64378 7.71482 1.77041 7.63672 1.84851L1.91418 7.57108H15.7998C15.9102 7.57108 15.9998 7.66062 15.9998 7.77108V8.37108C15.9998 8.48153 15.9102 8.57108 15.7998 8.57108H1.91418L7.63672 14.2936C7.71482 14.3717 7.71482 14.4983 7.63672 14.5764L7.21247 15.0007C7.13436 15.0788 7.00773 15.0788 6.92962 15.0007L0.141421 8.2125C0.0633163 8.13439 0.0633162 8.00776 0.141421 7.92965L6.92962 1.14142Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.0882482ae4dd3b6cadb5c2633535fecf.svg";
export { ForwardRef as ReactComponent };